import { API_BASE_URL } from "src/config/apiBase";
import { GripHorizontal, Image, LucideMousePointerClick, MessageSquareText, ArrowLeft, Sparkles, PenLine } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import TipTapDescriptionBox from "./TipTapDescriptionBox";
import ImageBox from "./ImageBox";
import CategorySelector from "./CategorySelector";
import TagsSelector from "./TagsSelector";
import BlogStatusBox from "./BlogStatusBox";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BlogStatusBox2Edit from "./BlogStatusBox2Edit";
import BlogSeoPanel from "./BlogSeoPanel";
import {
    SECTION_META,
    countWords,
    SectionActions,
    EditorInsertDock,
    makeEmptyRaw,
} from "./blogEditorShared";
import "./AddBlog.css";
import "./BlogEditor.css";
import slugify from "./slugify";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import OmsSpinnerData from "../Loader/Spinner";
const toYouTubeEmbed = (url) => {
    if (!url) return null;

    if (url.includes("youtu.be/")) {
        return `https://www.youtube.com/embed/${url.split("youtu.be/")[1].split("?")[0]}`;
    }

    if (url.includes("watch?v=")) {
        return `https://www.youtube.com/embed/${url.split("watch?v=")[1].split("&")[0]}`;
    }

    return null;
};



const parseDescription = (content) => {
    try {
        if (!content) return null;

        let parsed = content;

        // content is a JSON string from DB
        if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
        }

        // parsed at this point should be:  { blocks:[], entityMap:{} }
        if (parsed.blocks && parsed.entityMap) {
            return parsed;
        }

        return null;
    } catch (err) {
        console.error("parseDescription error:", err);
        return null;
    }
};



const EditBlog = () => {
    const [title, setTitle] = useState("");
    const [sections, setSections] = useState([
        { id: 1, type: "description", content: makeEmptyRaw() },
    ]);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [activeSectionId, setActiveSectionId] = useState(null);
    const textareaRefs = useRef({});
    const sectionRefs = useRef({});
    const [allCategories, setAllCategory] = useState([])
    const [allTags, setAllTags] = useState([])
    const url = API_BASE_URL
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [featureImage, setFeatureImage] = useState(null);
    const { id } = useParams()
    const [author, setAuthor] = useState([])
    const [selectedAuthor, setSelectedAuthor] = useState()
    const [isEdit, setIsEdit] = useState(true)
    const [status, setStatus] = useState("Draft");
    const [blogVisibility, setBlogVisibility] = useState("Public");
    const [password, setPassword] = useState("");
    const [slug, setSlug] = useState("")
    const token = decryptToken("accessToken") || "";
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [website, setWebsite] = useState(null)
    const [load, setLoad] = useState(false);
    const [excerpt, setExcerpt] = useState("");
    const [metaTitle, setMetaTitle] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [ogImage, setOgImage] = useState("");
    const [canonicalUrl, setCanonicalUrl] = useState("");
    const [publishedAt, setPublishedAt] = useState("");
    const [featured, setFeatured] = useState(false);

    const toDatetimeLocal = (value) => {
        if (!value) return "";
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return "";
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const navigate = useNavigate();

    const onDragEnd = async (result) => {
        if (!result.destination) return;

        const reorderedSections = Array.from(sections);
        const [movedSection] = reorderedSections.splice(result.source.index, 1);
        reorderedSections.splice(result.destination.index, 0, movedSection);
        setSections(reorderedSections);

        // Optionally update backend order immediately
        try {
            const payload = reorderedSections.map((s, index) => ({ id: s.id, order: index }));
            await fetch(`${url}/blog/${id}/sections/reorder`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
                body: JSON.stringify({ sections: payload }),
            });
        } catch (err) {
            console.error("Error updating section order:", err);
        }
    };


    const fetchCategoriesData = async () => {
        try {
            const response = await fetch(`${url}/blog-category`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAllCategory(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchAuthorData = async () => {
        try {
            const response = await fetch(`${url}/blog-author`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAuthor(Array.isArray(res.data) ? res.data : []);
        } catch (error) {
            console.log(error);
            setAuthor([]);
        }
    }

    // const fetchSingleData = async () => {
    //     try {
    //         const response = await fetch(`${url}/api/blog/single/${id}`);
    //         const res = await response.json();
    //         if (res.success && res.data) {
    //             const blog = res.data;

    //             // 1️⃣ Title
    //             setTitle(blog.title || "");

    //             // 2️⃣ Sections
    //             setSections(
    //                 blog.sections
    //                     ? [...blog.sections].sort((a, b) => a.order - b.order)
    //                     : []
    //             );

    //             // 3️⃣ Feature Image

    //             setFeatureImage(blog.feature_image ? { image: blog.feature_image } : null);



    //             // 4️⃣ Categories
    //             if (blog.categories && blog.categories.length > 0) {
    //                 const selectedCats = blog.categories.map((c) => ({
    //                     id: c.categoryDetails.id,
    //                     name: c.categoryDetails.name,
    //                     parent: c.categoryDetails.parentDetails
    //                         ? { id: c.categoryDetails.parentDetails.id, name: c.categoryDetails.parentDetails.name }
    //                         : null,
    //                 }));
    //                 console.log(selectedCats)
    //                 setSelectedCategory(selectedCats); // pass array to your CategorySelector
    //             }


    //             // 5️⃣ Tags
    //             if (blog.tags && blog.tags.length > 0) {
    //                 const tags = blog.tags.map((t) => ({
    //                     id: t.tagDetails.id,
    //                     name: t.tagDetails.name,
    //                 }));
    //                 setSelectedTags(tags); // pass array to TagsSelector
    //             }


    //             // 6️⃣ Status
    //             setStatus(blog.status || "draft");
    //             setSelectedAuthor(blog.author_name)
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };


    const fetchSingleData = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/blog/single/${id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            if (!response.ok || !res.success || !res.data) {
                console.error("Failed to load blog:", res.message || res.error || response.status);
                return;
            }

            const blog = res.data;

                // 1️⃣ Title
                setTitle(blog.title || "");
                setSlug(blog.slug);
                setExcerpt(blog.excerpt || "");
                setMetaTitle(blog.meta_title || "");
                setMetaDescription(blog.meta_description || "");
                setOgImage(blog.og_image || "");
                setCanonicalUrl(blog.canonical_url || "");
                setPublishedAt(toDatetimeLocal(blog.published_at));
                setFeatured(Boolean(blog.featured));
                // 2️⃣ Sections
                setSections(
                    blog.sections
                        ? blog.sections
                            .sort((a, b) => a.order - b.order)
                            .map((sec) => {
                                if (sec.type === "description") {
                                    return {
                                        ...sec,
                                        content: parseDescription(sec.content),
                                    };
                                }
                                // image / button
                                return {
                                    ...sec,
                                    content:
                                        typeof sec.content === "string"
                                            ? JSON.parse(sec.content)
                                            : sec.content,
                                };
                            })
                        : []
                );


                // 3️⃣ Feature Image
                setFeatureImage(blog.feature_image ? { image: blog.feature_image } : null);

                // 4️⃣ Categories
                if (blog.categories?.length) {
                    const selectedCats = blog.categories.map((c) => ({
                        id: c.categoryDetails.id,
                        name: c.categoryDetails.name,
                        parent: c.categoryDetails.parentDetails
                            ? {
                                id: c.categoryDetails.parentDetails.id,
                                name: c.categoryDetails.parentDetails.name,
                            }
                            : null,
                    }));
                    setSelectedCategory(selectedCats);
                }

                // 5️⃣ Tags
                if (blog.tags?.length) {
                    const tags = blog.tags.map((t) => ({
                        id: t.tagDetails.id,
                        name: t.tagDetails.name,
                    }));
                    setSelectedTags(tags);
                }

                // 6️⃣ Status
                setStatus(blog.status || "Draft");

                // 7️⃣ Visibility + Password
                setBlogVisibility(blog.visibility || "Public");
                setPassword(blog.password || "");

                // 8️⃣ Author
                setSelectedAuthor(blog.author_name ? { title: blog.author_name } : null);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false);
        }
    };


    const fetchTagData = async () => {
        try {
            const response = await fetch(`${url}/blog-tag`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAllTags(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const addSection = (type, content = {}) => {
        const newSection = {
            id: Date.now(),
            type,
            content: type === "description" ? makeEmptyRaw() : content,
            showTooltip: type === "image" ? false : undefined,
        };

        let updatedSections = [...sections];
        let scrollToSection = false;

        // Check if active section is the 2nd section (index 1) and adding description
        if (type === "description" && activeSectionId === sections[1]?.id && sections.length >= 2) {
            // Add description as the 3rd section (index 2)
            updatedSections.splice(2, 0, newSection);

            // Move existing image section (if any) at index 2 to index 3
            const imageSectionIndex = updatedSections.findIndex(
                (s, i) => i === 2 && s.type === "image"
            );
            if (imageSectionIndex !== -1) {
                const [imageSection] = updatedSections.splice(imageSectionIndex, 1);
                updatedSections.splice(3, 0, imageSection);
            }
            scrollToSection = true;
        } else {
            // Default: Add section at the end
            updatedSections.push(newSection);
            scrollToSection = true; // Scroll to new section for all types
        }

        setSections(updatedSections);

        // Scroll to the newly added section for all types
        if (scrollToSection) {
            setTimeout(() => {
                const sectionElement = sectionRefs.current[newSection.id];
                if (sectionElement) {
                    sectionElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 100); // Small delay to ensure DOM updates
        }
    };

    const duplicateSection = (id) => {
        const section = sections.find((s) => s.id === id);
        if (section) {
            const newSection = { ...section, id: Date.now() };
            setSections([...sections, newSection]);

            // Scroll to duplicated section for all types
            setTimeout(() => {
                const sectionElement = sectionRefs.current[newSection.id];
                if (sectionElement) {
                    sectionElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 100);
        }
    };

    const deleteSection = (id) => {
        if (sections.length === 1 && sections[0].type === "description") {
            alert("At least one description section is required.");
            return;
        }
        setSections(sections.filter((s) => s.id !== id));
        if (activeSectionId === id) {
            setActiveSectionId(null);
        }
    };

    const handleImageSelect = (imageObj, sectionId = null) => {
        if (sectionId) {
            setSections(
                sections.map((s) =>
                    s.id === sectionId
                        ? { ...s, content: { ...s.content, url: imageObj.url, title: s.content.title || "" } }
                        : s
                )
            );
        } else {
            addSection("image", { url: imageObj.url, title: "" });
        }
        setIsImageModalOpen(false);
    };

    const handleDescriptionFocus = (sectionId) => {
        setActiveSectionId(sectionId);
    };

    const handleDescriptionBlur = () => {
        setActiveSectionId(null);
    };


    const handleSubmit = async ({ status, visibility, password, action }) => {
        if (!title.trim()) {
            alert("Please enter a title.");
            return;
        }

        const normalizedStatus = status.toLowerCase();
        const stringifyContent = (section) => {
            if (section.type === "description") {
                return JSON.stringify(section.content); // 🔥 convert RAW object to JSON string
            }
            return section.content; // images/buttons remain object
        };


        // const payload = {
        //     title,
        //     sections,
        //     category_id: selectedCategory ? selectedCategory.id : null,
        //     tags: selectedTags,
        //     // feature_image: featureImage,
        //     status,
        // };

        // const payload = {
        //     title,
        //     feature_image: featureImage?.image, // from your upload or URL
        //     sections: sections.map((section, index) => ({
        //         ...section,
        //         order: index,
        //     })),
        //     categories: selectedCategory,    // from your CategorySelector (array of objects)
        //     tags: selectedTags,          // optional
        //     status: status,
        //     author_name: selectedAuthor?.title || selectedAuthor,
        // };

        // const payload = {
        //     title,
        //     feature_image: featureImage?.image,
        //     sections: sections.map((section, index) => ({
        //         ...section,
        //         order: index,
        //     })),
        //     categories: selectedCategory,
        //     tags: selectedTags,
        //     status,
        //     visibility: blogVisibility,
        //     password: blogVisibility === "Password" ? password : null,
        //     author_name: selectedAuthor?.title || selectedAuthor,
        // };

        // const payload = {
        //     title,
        //     feature_image: featureImage?.image,
        //     sections: sections.map((section, index) => ({
        //         ...section,
        //         order: index,
        //     })),
        //     categories: selectedCategory,
        //     tags: selectedTags,

        //     status: status,
        //     visibility: visibility,
        //     password: visibility === "Password" ? password : null,

        //     author_name: selectedAuthor?.title || selectedAuthor,
        // };


        const payload = {
            title,
            slug,
            feature_image: featureImage?.image,

            sections: sections.map((section, index) => ({
                id: section.id,
                type: section.type,
                content: stringifyContent(section),  // 🔥 FIX
                order: index,
            })),

            categories: selectedCategory,
            tags: selectedTags,
            status: normalizedStatus,
            visibility,
            password: visibility === "Password" ? password : null,
            author_name: selectedAuthor?.title || selectedAuthor,
            excerpt,
            meta_title: metaTitle,
            meta_description: metaDescription,
            og_image: ogImage || featureImage?.image || null,
            canonical_url: canonicalUrl,
            published_at: publishedAt || null,
            featured,
        };




        try {
            const res = await fetch(`${url}/blog/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (res.ok) {
                if (action === "preview") {
                    window.open(`/admin/preview-blog/${data.data.slug}/${data.data.id || "temp"}`, "_blank");
                    window.location.href = (`/edit-blog/${data.data.id}`)

                } else {
                    navigate("/blog")
                    toast.success("✅ Blog saved successfully!", {
                        position: "top-center",
                        autoClose: 2000
                    });
                }
            } else {
                alert("❌ Failed to save blog: " + data.message);
            }
        } catch (err) {
            console.error(err);
            alert("Error saving blog. Check console for details.");
        }
    };

    const fetchSingleuser = async () => {
        try {
            const response = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
                method: "GET",

                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });
            const res = await response.json();
            setWebsite(res?.users?.website_link || "")
            // setUserData(res.users);
            // setFormData(res.users);
            // setOriginalFormData(res.users);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCategoriesData();
        fetchTagData();
        fetchSingleData();
        fetchAuthorData();
        fetchSingleuser();
    }, [])

    if (load) {
        return <OmsSpinnerData />;
    }

    const wordCount = countWords(sections);

    return (
        <div className="add-blog-page">
            <header className="add-blog-hero">
                <div className="add-blog-hero-top">
                    <button type="button" className="add-blog-back" onClick={() => navigate("/blog")}>
                        <ArrowLeft size={16} />
                        All blogs
                    </button>
                    <div className="add-blog-hero-meta">
                        <span className="add-blog-pill">
                            <Sparkles size={12} style={{ display: "inline", marginRight: 4, verticalAlign: -2 }} />
                            Editing
                        </span>
                        <span className="add-blog-stat">{sections.length} blocks</span>
                        <span className="add-blog-stat">{wordCount} words</span>
                    </div>
                </div>
                <div className="add-blog-title-wrap">
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Your headline goes here…"
                        className="add-blog-title-input"
                        aria-label="Blog title"
                    />
                    {website && slug ? (
                        <p className="add-blog-title-hint">
                            <button
                                type="button"
                                className="text-[#4e59c2] hover:underline"
                                onClick={() =>
                                    window.open(`${website}/blog/${slugify(slug)}`, "_blank")
                                }
                            >
                                {website}/blog/{slug}
                            </button>
                        </p>
                    ) : (
                        <p className="add-blog-title-hint">
                            <PenLine size={12} style={{ display: "inline", marginRight: 4, verticalAlign: -1 }} />
                            Update slug in SEO panel
                        </p>
                    )}
                </div>
            </header>

            <div className="add-blog-layout">
                <main className="add-blog-canvas">
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="sections">
                        {(provided) => (
                            <div className="add-blog-timeline" {...provided.droppableProps} ref={provided.innerRef}>
                                {sections.map((section, index) => (
                                    <Draggable key={section.id} draggableId={String(section.id)} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={(el) => {
                                                    provided.innerRef(el);
                                                    sectionRefs.current[section.id] = el;
                                                }}
                                                {...provided.draggableProps}
                                                className={`add-blog-section add-blog-section--${SECTION_META[section.type]?.typeClass || "description"}`}
                                            >
                                                <div className="add-blog-section-head">
                                                    <div className="add-blog-section-label">
                                                        <span className="add-blog-section-index">{index + 1}</span>
                                                        {SECTION_META[section.type]?.label || section.type}
                                                    </div>
                                                    <div className="add-blog-drag" {...provided.dragHandleProps}>
                                                        <GripHorizontal size={18} />
                                                    </div>
                                                </div>
                                                <div className="add-blog-section-body">
                                                {section.type === "description" && (
                                                    <TipTapDescriptionBox
                                                        content={section.content.raw || section.content}
                                                        onChange={(raw) => {
                                                            setSections(sections.map(s =>
                                                                s.id === section.id
                                                                    ? { ...s, content: raw }
                                                                    : s
                                                            ));
                                                        }}
                                                        textareaRef={(el) => (textareaRefs.current[section.id] = el)}
                                                        onFocus={() => handleDescriptionFocus(section.id)}
                                                        onBlur={handleDescriptionBlur}
                                                    />
                                                )}
                                                {section.type === "image" && (() => {
                                                    const rawContent =
                                                        typeof section.content === "string"
                                                            ? JSON.parse(section.content)
                                                            : section.content || {};

                                                    const contentObj = {
                                                        title: rawContent.title || "",
                                                        images: rawContent.images || (
                                                            rawContent.image || rawContent.url
                                                                ? [{ image: rawContent.image || rawContent.url }]
                                                                : []
                                                        ),
                                                    };


                                                    return (
                                                        <div>
                                                            <input
                                                                type="text"
                                                                value={contentObj.title}
                                                                onChange={(e) => {
                                                                    const updated = { ...rawContent, title: e.target.value };
                                                                    setSections(
                                                                        sections.map((s) =>
                                                                            s.id === section.id ? { ...s, content: updated } : s
                                                                        )
                                                                    );
                                                                }}
                                                                placeholder="Enter image title"
                                                                className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                            />

                                                            <div className="my-3 flex justify-center items-center">
                                                                <ImageBox
                                                                    mode="multiple"
                                                                    selectedImages={contentObj.images}
                                                                    onSelect={(imagesArray) => {
                                                                        setSections(
                                                                            sections.map((s) =>
                                                                                s.id === section.id
                                                                                    ? {
                                                                                        ...s,
                                                                                        content: {
                                                                                            ...rawContent,
                                                                                            images: imagesArray
                                                                                        }
                                                                                    }
                                                                                    : s
                                                                            )
                                                                        );
                                                                    }}

                                                                />


                                                            </div>
                                                        </div>
                                                    );
                                                })()}



                                                {section.type === "button" && (
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                        <input
                                                            type="text"
                                                            value={section.content.text}
                                                            onChange={(e) => {
                                                                setSections(
                                                                    sections.map((s) =>
                                                                        s.id === section.id ? { ...s, content: { ...s.content, text: e.target.value } } : s
                                                                    )
                                                                );
                                                            }}
                                                            placeholder="Enter button text"
                                                            className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                        />
                                                        <input
                                                            type="text"
                                                            value={section.content.action}
                                                            onChange={(e) => {
                                                                setSections(
                                                                    sections.map((s) =>
                                                                        s.id === section.id ? { ...s, content: { ...s.content, action: e.target.value } } : s
                                                                    )
                                                                );
                                                            }}
                                                            placeholder="Enter button action (e.g., URL or function)"
                                                            className="add-blog-field-input"
                                                        />
                                                    </div>
                                                )}
                                                </div>
                                                <SectionActions
                                                    onDuplicate={() => duplicateSection(section.id)}
                                                    onDelete={() => deleteSection(section.id)}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>


                    {isImageModalOpen && (
                        <ImageBox
                            selectedImage={null}
                            onSelect={handleImageSelect}
                            onDelete={() => setIsImageModalOpen(false)}
                            onClose={() => setIsImageModalOpen(false)}
                        />
                    )}
                </main>

                <aside className="add-blog-deck">
                    <div className="add-blog-deck-sticky">
                        <div className="add-blog-deck-card add-blog-deck-card--publish">
                            <div className="add-blog-deck-card-head">Ready to publish?</div>
                            <div className="add-blog-deck-card-body">
                                <BlogStatusBox2Edit
                                    blogId={id}
                                    status={status}
                                    setStatus={setStatus}
                                    visibility={blogVisibility}
                                    setVisibility={setBlogVisibility}
                                    password={password}
                                    setPassword={setPassword}
                                    onSuccess={handleSubmit}
                                    isEdit={true}
                                    slug={slug}
                                />
                            </div>
                        </div>

                        <div className="add-blog-deck-card">
                            <div className="add-blog-deck-card-body">
                                <BlogSeoPanel
                                    slug={slug}
                                    setSlug={setSlug}
                                    showSlug
                                    excerpt={excerpt}
                                    setExcerpt={setExcerpt}
                                    metaTitle={metaTitle}
                                    setMetaTitle={setMetaTitle}
                                    metaDescription={metaDescription}
                                    setMetaDescription={setMetaDescription}
                                    ogImage={ogImage}
                                    setOgImage={setOgImage}
                                    canonicalUrl={canonicalUrl}
                                    setCanonicalUrl={setCanonicalUrl}
                                    publishedAt={publishedAt}
                                    setPublishedAt={setPublishedAt}
                                    featured={featured}
                                    setFeatured={setFeatured}
                                />
                            </div>
                        </div>

                        <div className="add-blog-deck-card">
                            <div className="add-blog-deck-card-body">
                                <AuthorSelect
                                    authors={author}
                                    onSelect={(a) => setSelectedAuthor(a)}
                                    fetchAuthors={fetchAuthorData}
                                    value={selectedAuthor}
                                />
                            </div>
                        </div>

                        <div className="add-blog-deck-card">
                            <div className="add-blog-deck-card-head">Cover image</div>
                            <div className="add-blog-deck-card-body">
                                <ImageBox
                                    mode="single"
                                    selectedImage={
                                        featureImage?.image
                                            ? { image: featureImage.image }
                                            : { image: "" }
                                    }
                                    onSelect={(imgObj) => {
                                        const imageUrl = imgObj.image || imgObj.url;
                                        setFeatureImage({ image: imageUrl });
                                    }}
                                    onDelete={() => setFeatureImage(null)}
                                />
                            </div>
                        </div>

                        <div className="add-blog-deck-card">
                            <div className="add-blog-deck-card-body">
                                <CategorySelector
                                    categories={allCategories}
                                    onSelect={setSelectedCategory}
                                    selected={selectedCategory}
                                />
                            </div>
                        </div>

                        <div className="add-blog-deck-card">
                            <div className="add-blog-deck-card-body">
                                <TagsSelector tags={allTags} onChange={setSelectedTags} selected={selectedTags} />
                            </div>
                        </div>
                    </div>
                </aside>
            </div>

            <EditorInsertDock addSection={addSection} />
        </div>
    );
};

const AuthorSelect = ({ authors = [], onSelect, fetchAuthors, value }) => {
    const [search, setSearch] = useState("");
    const [filteredAuthors, setFilteredAuthors] = useState(authors);
    const [selectedAuthor, setSelectedAuthor] = useState(value);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (value) setSelectedAuthor(value);
    }, [value]);

    // ✅ Fetch authors if not loaded
    useEffect(() => {
        if (!authors.length && fetchAuthors) fetchAuthors();
    }, [authors, fetchAuthors]);

    // ✅ Filter authors on search
    useEffect(() => {
        if (authors.length > 0) {
            setFilteredAuthors(
                authors.filter((a) =>
                    a.title.toLowerCase().includes(search.toLowerCase())
                )
            );
        }
    }, [search, authors]);

    // ✅ Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (author) => {
        setSelectedAuthor(author);
        if (onSelect) onSelect(author);
        setIsOpen(false); // close dropdown
        setSearch(""); // clear search
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <label className="text-[15px] font-semibold text-gray-800 mb-1 block">
                Author
            </label>

            {/* Selected Author / Search Box */}
            <div
                onClick={() => setIsOpen((prev) => !prev)}
                className="border border-gray-300 rounded-lg px-3 py-2 flex justify-between items-center text-sm cursor-pointer bg-white focus-within:ring-2 focus-within:ring-blue-400"
            >
                {console.log(selectedAuthor)}
                {selectedAuthor ? (
                    <span>{selectedAuthor?.title || selectedAuthor}</span>
                ) : (
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setIsOpen(true);
                        }}
                        placeholder="Search author..."
                        className="outline-none w-full bg-transparent"
                    />
                )}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""
                        }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </div>

            {/* Dropdown List */}
            {isOpen && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-40 overflow-y-auto">
                    {filteredAuthors.length > 0 ? (
                        filteredAuthors.map((author) => (
                            <div
                                key={author.id}
                                onClick={() => handleSelect(author)}
                                className="px-3 py-2 text-sm hover:bg-blue-100 cursor-pointer"
                            >
                                {author.title}
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-400 text-sm px-3 py-2">No authors found</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default EditBlog;